import { Builder } from '@builder.io/react';

import { Button } from '@catawiki/cata-style';

import { cleanBuilderStringInput } from '../../text';

interface BuilderInput {
  text: string;
  link: string;
  openInNewTab: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attributes: any;
}

type Props = BuilderInput & {
  locale: string;
};

export const BuilderButton = ({ link, text, attributes }: Props) => (
  <Button as="a" href={cleanBuilderStringInput(link, true)} {...attributes}>
    {cleanBuilderStringInput(text, true)}
  </Button>
);

export function dataFetcher(locale: string) {
  return async () => ({
    locale,
  });
}

export function componentRegister() {
  const name = 'Button';
  Builder.registerComponent(BuilderButton, {
    name,
    image:
      'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13',
    inputs: [
      {
        name: 'text',
        friendlyName: 'Text',
        type: 'string',
      },
      {
        name: 'link',
        friendlyName: 'Link',
        type: 'string',
      },
      {
        name: 'openInNewTab',
        type: 'boolean',
      },
    ],
    hideFromInsertMenu: true,
    noWrap: true,
  });
  return name;
}
